/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Note/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Note({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Notes/Content/Note/Note"
  
}) {
let dtColorsGreen100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.100'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let noteNoteValueData = fromData.useDataValue({ viewPath,
context: 'note',
path: 'note',
})
  return (<React.Fragment
>
<div
  data-testid="Note.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-aI8I': dtColorsGreen100,'--pl-2-aI8I': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-3-aI8I': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-4-aI8I': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-5-aI8I': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bblr-6-aI8I': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bbrr-7-aI8I': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--btlr-8-aI8I': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--btrr-9-aI8I': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mt-10-aI8I': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="note.note"
 text={noteNoteValueData}
 whiteSpace="pre-wrap"
/>
</div>
{children}
</React.Fragment>)
}